import script from "./footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./footer.vue?vue&type=script&lang=ts&setup=true"

import "./footer.vue?vue&type=style&index=0&id=0172ebc0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0172ebc0"]])

export default __exports__